"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _link = _interopRequireDefault(require("../Link/link"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EmptyWidget = function EmptyWidget(_ref) {
  var children = _ref.children,
      title = _ref.title,
      message = _ref.message,
      actionHandler = _ref.actionHandler,
      large = _ref.large,
      actionText = _ref.actionText,
      props = _objectWithoutProperties(_ref, ["children", "title", "message", "actionHandler", "large", "actionText"]);

  var action = actionHandler ? _react.default.createElement(_link.default, {
    onClick: actionHandler
  }, " ", actionText) : null;
  return _react.default.createElement(_styler.default, {
    classNames: "co-empty-state",
    modifiers: {
      large: large
    }
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), _react.default.createElement("div", {
      className: "co-empty-state__image"
    }, children), _react.default.createElement("h2", null, title), _react.default.createElement("p", null, message, action));
  });
};

EmptyWidget.propTypes = {
  /** Children should be <Icon /> or <Image /> */
  children: _propTypes.any.isRequired,
  title: _propTypes.string.isRequired,
  message: (0, _propTypes.oneOfType)([_propTypes.element, _propTypes.string]).isRequired,
  actionHandler: _propTypes.func,
  actionText: _propTypes.string,
  large: _propTypes.bool
};
EmptyWidget.defaultProps = {
  actionText: 'Please try again.'
};
var _default = EmptyWidget;
exports.default = _default;
EmptyWidget.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EmptyWidget",
  "props": {
    "actionText": {
      "defaultValue": {
        "value": "'Please try again.'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "Children should be <Icon /> or <Image />"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "message": {
      "type": {
        "name": "union",
        "value": [{
          "name": "element"
        }, {
          "name": "string"
        }]
      },
      "required": true,
      "description": ""
    },
    "actionHandler": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "large": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};